import * as React from 'react';
import { LoaderSlate } from 'src/components/Loaders';
import { INewsItem, INewsListItem } from 'src/Entities/News/NewsItem';
import { fetchNews, fetchNewsDetails } from 'src/helpers/api';
import NewsModal from '.';
import Content from './Content';
import Sidebar from './Sidebar';

export interface INewsArchiveModalContainerProps {
  onCloseClick: () => void;
}

interface INewsArchiveState {
  status: 'idle' | 'loading' | 'loaded' | 'error';
  initialized: boolean;
  page: number;
  totalPages: number;
  news: INewsListItem[];
  activeNewsId: number | null;
}

interface INewsArchiveDetailsState {
  status: 'idle' | 'loading' | 'loaded' | 'error';
  item: INewsItem | null;
};

const NewsArchiveModalContainer = ({ onCloseClick }: INewsArchiveModalContainerProps) => {
  const [state, setState] = React.useState<INewsArchiveState>({
    status: 'idle',
    initialized: false,
    page: 1,
    totalPages: 0,
    news: [],
    activeNewsId: null,
  });
  const [details, setDetails] = React.useState<INewsArchiveDetailsState>({
    status: 'idle',
    item: null,
  });

  const activeListItem = React.useMemo(() => {
    return state.news.find((item) => item.id === state.activeNewsId);
  }, [state.news, state.activeNewsId]);

  const fetch = (page: number = state.page) => {
    setState({ ...state, status: 'loading' });

    fetchNews(page, 10, true)
      .then((response) => {
        const firstNewsItem = response.newsList[0];

        setState({
          ...state,
          status: 'loaded',
          initialized: true,
          page: response.page,
          totalPages: response.totalPages,
          news: response.newsList,
          activeNewsId: !state.activeNewsId && firstNewsItem
            ? firstNewsItem.id
            : state.activeNewsId
        });
      })
      .catch((error) => {
        setState({ ...state, initialized: true, status: 'error' });
      });
  };

  // Fetch list
  React.useEffect(() => {
    fetch(0);
  }, []);

  // Fetch active
  React.useEffect(() => {
    if (state.activeNewsId) {
      setDetails({ ...details, status: 'loading' });

      fetchNewsDetails(state.activeNewsId)
        .then((item) => {
          setDetails({
            ...details,
            status: 'loaded',
            item
          });
        })
        .catch((error) => {
          setDetails({ ...details, status: 'error' });
        });
    }
  }, [state.activeNewsId]);

  const handleFetchPageClick = (page: number) => {
    fetch(page);
  };

  const handleItemClick = (item: INewsListItem) => {
    setState({ ...state, activeNewsId: item.id });
  };

  if (!state.initialized) {
    return (
      <NewsModal onCloseClick={onCloseClick} title="Nyhedsarkiv">
        <div className="has-background-white p-14 flex-auto">
          <LoaderSlate />
        </div>
      </NewsModal>
    );
  }

  if (state.initialized && state.totalPages === 0) {
    return (
      <NewsModal onCloseClick={onCloseClick} title="Nyhedsarkiv">
        <div className="has-background-white p-14 flex-auto">
          <div className="min-h-104 flex items-center justify-center font-semibold has-text-black">
            Nyhedsarkivet er tomt
          </div>
        </div>
      </NewsModal>
    );
  }

  return (
    <NewsModal onCloseClick={onCloseClick} title="Nyhedsarkiv">
      <Sidebar
        news={state.news}
        isLoading={state.status === 'loading'}
        totalPages={state.totalPages}
        currentPage={state.page}
        activeNewsItemId={state.activeNewsId}
        onItemClick={handleItemClick}
        onFetchPageClick={handleFetchPageClick}
      />
      <Content
        item={details.item ? details.item : activeListItem}
        status={details.status}
      />
    </NewsModal>
  );
};

export default NewsArchiveModalContainer;



// WEBPACK FOOTER //
// ./src/components/News/NewsModal/NewsArchiveContainer.tsx